import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./LoginStatus.module.css";
import PushButton from "../../../UI/Buttons/PushButton/PushButton";
import Register from "../Register/Register";
import Login from "../Login/Login";
import { authActions } from "../../../store/authSlice";
import { deleteUserCookie } from "../../../storage/userDB";
import { useRunGatherCatalogData } from "../../../Hooks/useRunGatherCatalogData";
import { catalogDataActions } from "../../../store/catalogDataSlice";
import { clearPreviewOverlay } from "../../../data/cmsPreview";

function LoginStatus(props) {
  const userData = useSelector((state) => state.auth);
  const user = userData.user;
  const dispatch = useDispatch();
  const [showLoginForm, setShowLoginForm] = useState(true);
  const [showSignupForm, setShowSignupForm] = useState(false);
  // const [loginEmail, setLoginEmail] = useState("");
  // const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState(false);
  const horizontalDisplay = props.horizontalDisplay ? "horizontal-display" : "";
  const runGatherCatalogData = useRunGatherCatalogData();
  const toggleSignupLoginButtonHandler = () => {
    setShowLoginForm(!showLoginForm);
    setShowSignupForm(!showSignupForm);
  };

  const addAToolButtonHandler = () => {
    dispatch(catalogDataActions.goToAddATool());
  };

  const logOutButtonHandler = async () => {
    const shouldDelete = window.confirm("Are you sure you want to do this?");

    if (!shouldDelete) return;
    try {
      deleteUserCookie();
      clearPreviewOverlay();
      dispatch(authActions.logOut());
      runGatherCatalogData({ user: false });
      setLoginError(false);
    } catch (error) {
      setLoginError(
        "Unfortunately, we could not log you out. Please contact connect@ignite-elysium.com if the problem continues. Error received: " +
          error.message,
      );
    }
  };

  const isAdminVariant = props.variant === "admin";
  const hideStatus = props.hideStatus || isAdminVariant;
  const hideTitles = props.hideTitles || isAdminVariant;
  // Admin lock screen: sign-up disabled for now (re-enable by removing isAdminVariant from this line)
  const hideSignUp = props.hideSignUp || isAdminVariant;

  return (
    <div
      id="db-login-container"
      className={`${styles["inner-wrap"]} ${styles["db-login-container"]} ${
        styles[horizontalDisplay] || ""
      } ${isAdminVariant ? styles["admin-variant"] : ""}`}
    >
      {!hideStatus && (
        <p className={styles["db-login-status-container"]}>
          <span id="db-login-status" className={styles["db-login-status"]}>
            {user ? (
              <span className={styles["login-text"]}>
                {user.email} is Logged In
              </span>
            ) : (
              <span
                className={
                  styles["login-text"] + " " + styles["not-logged-in-text"]
                }
              >
                No one is logged in. Login to manage your music.
              </span>
            )}
          </span>
        </p>
      )}
      <div className={styles["button-container"]}>
        {!user && (
          <div className={styles["form-container"]}>
            {(showLoginForm || hideSignUp) && (
              <Login
                toggleSignupLoginButtonHandler={toggleSignupLoginButtonHandler}
                horizontalDisplay={props.horizontalDisplay}
                signUpButtonStyles={
                  isAdminVariant
                    ? {
                        margin: "0 0 0 0.5em",
                        boxShadow: "none",
                        border: "1px solid hsl(0 0% 30%)",
                        fontWeight: "600",
                        minHeight: "auto",
                        padding: "0.4em 1em",
                      }
                    : props.signUpButtonStyles
                }
                hideTitles={hideTitles}
                hideSignUp={hideSignUp}
              />
            )}
            {!hideSignUp && showSignupForm && (
              <Register
                toggleSignupLoginButtonHandler={toggleSignupLoginButtonHandler}
                horizontalDisplay={props.horizontalDisplay}
              />
            )}
          </div>
        )}

        {user && (
          <div className={isAdminVariant ? styles["admin-session"] : undefined}>
            {isAdminVariant && (
              <p className={styles["admin-session-email"]}>{user.email}</p>
            )}
            <PushButton
              inputOrButton="button"
              id="logout-from-db"
              colorType="secondary"
              value="logout from db"
              data=""
              size="small"
              onClick={logOutButtonHandler}
              styles={{
                margin: isAdminVariant ? "0" : "1em auto",
                textTransform: "uppercase",
              }}
            >
              Log Out
            </PushButton>
          </div>
        )}
        {loginError && (
          <p className={styles["admin-login-error"]}>{loginError}</p>
        )}
      </div>
      {props.showAddAQuestionButton && (
        <PushButton
          inputOrButton="button"
          id="create-entry-btn"
          colorType="secondary"
          value="Add a Question"
          data=""
          size="small"
          onClick={addAToolButtonHandler}
          styles={{
            width: "300px",
            letterSpacing: "var(--ms1-spacing-subheading)",
            fontVariant: "small-caps",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            margin: "1.5em auto",
            padding: "0.75em",
            transform: "none",
            borderRadius: "50px",
          }}
        >
          <span>Add a Question</span>
        </PushButton>
      )}
    </div>
  );
}

export default LoginStatus;
